/*
 * 使用本地图片
 * @param {string} img 图片名称.后缀， 如果是在assets的其他文件：'img/1.png'
 */
export default function localImage(img: string) {
  return new URL(`../assets/images/${img}`, import.meta.url).href
}
